module.exports = "<p>dialog works!</p>\r\n"